import { useNavigate } from 'react-router-dom'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'

const MyTrainingIndexRevamp = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  useEffect(() => {
    navigate(navigation.myTrainings.revamp.overview.path)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>
}
export default MyTrainingIndexRevamp
